// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__13O54","header":"Messages_header__2PG1P"};